import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtCreditCardSelectorItemComponent } from '../bt-credit-card-selector-item/bt-credit-card-selector-item.component';
import { IBtCreditCard } from '../../interfaces/braintree.interfaces';


@Component({
  standalone: true,
  selector: 'equine-ui-nx-bt-credit-card-selector',
  imports: [CommonModule, BtCreditCardSelectorItemComponent],
  templateUrl: './bt-credit-card-selector.component.html',
  styleUrl: './bt-credit-card-selector.component.scss',
})
export class BtCreditCardSelectorComponent implements OnInit {

  @Input() creditCards: IBtCreditCard[] = [];
  @Output() tokenSelected: EventEmitter<string | null> = new EventEmitter<string | null>();

  selectedItemToken: string | null = null;

  ngOnInit(): void {
    void 0;
  }

  creditCardSelected(token: string) {
    this.selectedItemToken = token;
    this.tokenSelected.emit(token);
  }

}
